import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { Tooltip, useTheme } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { findObjById, getLabelById, newRow } from "./constant";
import CustomPaginationWithoutCount from "components/CustomPaginationWithoutCount/CustomPaginationWithoutCount";
import { GridRowModes } from "@mui/x-data-grid";
import {
  capitalize,
  generateRandomId,
  isObjEmpty,
} from "../../common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";
import { saveOrDeleteMsg } from "../../edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { editCellContainerStyle } from "../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import AAutoComplete from "../../common/form-fields-mui/AAutoComplete";
import {
  ActionsCellComponent,
  StatusCellComponent,
} from "../../masters/studentFinancials/paymentGatewaysConfiguration/common";
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseSquareBlack.svg";
import { constants } from "../../common/constant";
import AInput from "../../common/formFeilds/customInput/AInput";
import APopover from "../../common/a-popover";
import IconButtonWrapper from "../../common/form-fields-mui/IconButtonWrapper";
import { BsThreeDotsVertical } from "react-icons/bs";
import { REACT_ICONS_STYLE } from "../../masters/studentFinancials/paymentCollection/manage-receipts/constants";
import { useHistory } from "react-router-dom";
import CustomChip from "../../common/customChip/CustomChip";
import ALoader from "../../common/a-loader";
import AButton from "../../common/form-fields-mui/AButton";
import AccountEntrySetupDialog from "./accountingEntrySetup/AccountEntrySetupDialog";

const ListComponent = forwardRef(
  (
    {
      currentPage = 0,
      rowCount,
      rows,
      loader,
      createHandler,
      updateHandler,
      setIsNew,
      paymentCategoryList,
      companyCodeList,
      groupCodeList,
      onPageChange,
      isLastPage,
    },
    ref
  ) => {
    const [rowModesModel, setRowModesModel] = useState({});

    const [rowData, setRowData] = useState([]);
    const [rowForm, setRowForm] = useState({});
    let history = useHistory();
    const theme = useTheme();

    const [accountEntrySetupDialogInfo, setAccountEntrySetupDialogInfo] = useState({});

    const rowFormHandler = (value, key) =>
      setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
      const row = rows.map((item) => {
        const groupCodeId = findObjById(item?.groupCodeId, groupCodeList);
        const paymentCategory = findObjById(
          item?.paymentCategory,
          paymentCategoryList
        );
        const companyCodeId = findObjById(item?.companyCodeId, companyCodeList);
        const paymodeType = findObjById(
          item?.paymodeType,
          constants.paymentType
        );
        return {
          ...item,
          groupCodeId,
          companyCodeId,
          paymentCategory,
          paymodeType,
        };
      });
      setRowData(row);
    }, [rows, groupCodeList, paymentCategoryList]);

    const startEditing = (id, form) => {
      setRowModesModel((oldModel) => ({
        [id]: { mode: GridRowModes.Edit },
      }));
      setRowForm(form);
    };

    const stopEditing = () => {
      const currForm = { ...rowForm };
      setRowModesModel((oldModel) => ({
        [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
      }));
      setRowForm({});
    };

    const handleEditClick = (params) => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        startEditing(params?.id, params?.row);
      }
    };

    const handleCancelClick = async (params) => {
      if (params?.row?.isNew) {
        setRowData(rows);
        setRowForm({});
        setIsNew(false);
      } else {
        stopEditing(params?.id);
      }
    };

    const handleSaveClick = async (params) => {
      if (rowForm?.isNew) {
        await createHandler(rowForm);
        setIsNew(false);
      } else {
        await updateHandler(rowForm);
      }
    };
    const addNewRow = async () => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        let randomId = generateRandomId();
        let emptyRow = {
          ...newRow,
          isNew: true,
          id: randomId,
        };
        startEditing(randomId, emptyRow);
        setRowData((prev) => [emptyRow, ...prev]);
      }
    };

    useImperativeHandle(ref, () => ({
      addNewRow: addNewRow,
      startEditing: startEditing,
      stopEditing: stopEditing,
    }));

    const handleClick = (rowData) => {
      history.push(`/admin/paymentMode/process&RoleMapping/${rowData?.id}`);
    };

    const columns = [
      new AGridColDef("groupCodeId", "Group", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value.label}>
              <div className={`ellipsis-text-container`}>
                {params?.value.label}
              </div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.groupCodeId}
              handleChange={(value) => rowFormHandler(value, "groupCodeId")}
              items={groupCodeList}
              isMulti={false}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("companyCodeId", "Company", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value.label}>
              <div className={`ellipsis-text-container`}>
                {params?.value.label}
              </div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.companyCodeId}
              handleChange={(value) => rowFormHandler(value, "companyCodeId")}
              items={companyCodeList}
              isMulti={false}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("paymentModeKey", "Key", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              placeholder="Enter"
              value={rowForm?.paymentModeKey}
              handler={(value) => rowFormHandler(value, "paymentModeKey")}
            />
          </div>
        )),
      new AGridColDef("effectiveDate", "Eff. date", false)
        .setMinWidth(80)
        .editable(false)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={moment(params?.value).format("DD-MM-YYYY")}>
              <div className={`ellipsis-text-container`}>
                {moment(params?.value).format("DD-MM-YYYY")}
              </div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("paymentModeDesc", "Desc", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              placeholder="Enter"
              value={rowForm?.paymentModeDesc}
              handler={(value) => rowFormHandler(value, "paymentModeDesc")}
            />
          </div>
        )),
      new AGridColDef("paymentModeDispValue", "Disp. value", false)
        .setMinWidth(80)
        .editable(rowForm?.isNew)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              placeholder="Enter"
              value={rowForm?.paymentModeDispValue}
              handler={(value) => rowFormHandler(value, "paymentModeDispValue")}
            />
          </div>
        )),
      new AGridColDef("sapPaymode", "SAP Paymode", false)
        .setMinWidth(100)
        .editable(true)
        .setFlex(0.75)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              placeholder="Enter"
              value={rowForm?.sapPaymode}
              handler={(value) => rowFormHandler(value, "sapPaymode")}
            />
          </div>
        )),
      new AGridColDef("paymodeSequence", "Paymode seq.", true)
        .setMinWidth(100)
        .editable(true)
        .setFlex(0.75)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              placeholder="Enter"
              value={rowForm?.paymodeSequence}
              handler={(value) => rowFormHandler(value, "paymodeSequence")}
            />
          </div>
        )),
      new AGridColDef("paymodeType", "Payment type", false)
        .setMinWidth(100)
        .editable(true)
        .setFlex(0.75)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value.label}>
              <div className={`ellipsis-text-container`}>
                {params?.value.label}
              </div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.paymodeType}
              handleChange={(value) => rowFormHandler(value, "paymodeType")}
              items={constants.paymentType}
              isMulti={false}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("paymentCategory", "Category", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.75)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value.label}>
              <div className={`ellipsis-text-container`}>
                {params?.value.label}
              </div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.paymentCategory}
              handleChange={(value) => rowFormHandler(value, "paymentCategory")}
              items={paymentCategoryList}
              isMulti={false}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      
      // new AGridColDef("receiptAccountEntry", "Receipt Account Entry", false)
      //   .setMinWidth(120)
      //   // .editable(true)
      //   .setFlex(1)
      //   .renderCellComponent((params) =>
      //     <AButton
      //       variant="primary_filled"
      //       size="xs"
      //       className="no-ml-btn"
      //       onClick={() => {
      //         const {id, paymentModeKey} = params?.row;
      //         setAccountEntrySetupDialogInfo({
      //           isOpen : true,
      //           paymentModeId : id,
      //           paymentModeKey
      //         })
      //       }}
      //     >
      //       A/C Entry Detail
      //     </AButton>
      //   ), 

      new AGridColDef("status", "Status", false)
        .setMinWidth(70)
        .setFlex(0.6)
        .editable(true)
        .renderCellComponent((params) => (
          <CustomChip
            text={params?.value}
            textColor={params?.value == "ACTIVE" ? "#07794C" : "#DC2804"}
            bgColor={params?.value == "ACTIVE" ? "#E6F4ED" : "#FCEEED"}
            style={{ width: "105px" }}
          />
        ))
        .renderEditCellComponent((params) => (
          <span>
            <StatusCellComponent
              value={rowForm?.status}
              handleChange={(val) => rowFormHandler(val, "status")}
            />
            <span
              style={{
                fontSize: "14px",
                marginLeft: "4px",

                color: rowForm.status === "ACTIVE" ? "#0F0F0F" : "#757575",
              }}
            >
              {capitalize(rowForm.status)}
            </span>
          </span>
        )),

      new AGridColDef("actions", "Action", false)
        .setMinWidth(110)
        .setFlex(1)
        .editable(true)
        // .pinColumnLast(true)
        .columnAlign("right")
        .renderCellComponent((params) => (
          <>
            <ActionsCellComponent
              mode={"view"}
              handleEditClick={handleEditClick}
              params={params}
              icon={true}
            />
            &nbsp;&nbsp;&nbsp;
            <APopover
              buttonComponent={(onClick, styles) => (
                <Tooltip title="More Actions">
                  <span onClick={onClick}>
                    <IconButtonWrapper>
                      <BsThreeDotsVertical style={REACT_ICONS_STYLE} />
                    </IconButtonWrapper>
                  </span>
                </Tooltip>
              )}
              menuComponent={(closeForm) => (
                <span
                  className="tiny-semi-bold label-color cursor"
                  onClick={() => {
                    handleClick(params?.row);
                  }}
                >
                  Process and role mapping
                </span>
              )}
              sx={{
                "& .MuiPaper-root": {
                  border: `1px solid #E2E2E2`,
                  boxShadow: "0px 3px 4px 0px #00000014 !important",
                  borderRadius: "8px",
                  padding: "12px 16px",
                },
              }}
              // transformOriginVertical="center"
              // transformOriginHorizontal="left"
            />
          </>
        ))
        .renderEditCellComponent((params) => (
          <ActionsCellComponent
            mode={"edit"}
            handleSaveClick={handleSaveClick}
            // handleCancelClick={handleCancelClick}
            params={params}
            cancelIcon={
              <CloseIcon
                className="mx-2 cursor"
                onClick={() => handleCancelClick(params)}
              />
            }
          />
        )),
    ];
    return loader ? (
      <ALoader />
    ) : (
      <>
        <ADataGrid
          removeWrapperContainer
          rowModesModel={rowModesModel}
          rows={rowData || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          rowCount={rowCount}
          loading={false}
          hideFooterSelectedRowCount={true}
          components={{
            ...gridComponents,
            NoRowsOverlay: () => (
              <NoRowOverlay message={loader ? "Loading..." : null} />
            ),
          }}
          height="78%"
          sx={{
            minHeight: "85%",
            [theme.breakpoints.up("lg")]: {
              minHeight: "90%",
            },
          }}
          autoHeight
          hidePagination={true}
        />
        <CustomPaginationWithoutCount
          currentPage={currentPage}
          onPageChange={onPageChange}
          isLastPage={isLastPage}
          noOfCurrentPageRecords={rows.length}
        />

        <AccountEntrySetupDialog
        dialogInfo={accountEntrySetupDialogInfo}
        setDialogInfo={setAccountEntrySetupDialogInfo}
        key={accountEntrySetupDialogInfo?.paymentModeId}
        />
      </>
    );
  }
);
export default ListComponent;
